import z from 'zod';

export const trainerSummarySchema = z
    .object({
        id: z.string(),
        cheatCount: z.number(),
        supportedVersions: z.array(z.number()),
        releasedAt: z.string().nullable(),
        createdAt: z.string(),
    })
    .describe('TrainerSummary');
export type TrainerSummary = z.infer<typeof trainerSummarySchema>;

export const trainerHistorySchema = z.array(trainerSummarySchema).describe('TrainerHistory');
export type TrainerHistory = z.infer<typeof trainerHistorySchema>;

export const pinnedModsResponseSchema = z.object({ data: z.array(z.string()) }).describe('PinnedModsResponse');
export type PinnedModsResponse = z.infer<typeof pinnedModsResponseSchema>;
